import {
  Button,
  Checkbox,
  FormControlLabel,
  IconButton,
  MenuItem,
  Tooltip,
  InputAdornment,
  TextField,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  CircularProgress,
  Autocomplete,
  DialogActions,
  Grid,
  ToggleButton,
  ToggleButtonGroup,
} from '@mui/material';
import React, { useContext, useState, useRef, useEffect, useCallback, useMemo } from 'react';
import styles from './styles.module.css';
import CloseIcon from '@mui/icons-material/Close';
import ItemService from 'services/ItemService';
// import RestrictionInfo from 'components/utils/Alert/RestrictionInfo';
import { ShopContext } from 'Context/ShopContext';
import { STORAGE_KEYS, DAYS_OF_WEEK, PRODUCTS_TAG_SUGGESTIONS } from 'const';
import LibraryAddIcon from '@mui/icons-material/LibraryAdd';
import { AlertMessagesContext } from 'react-alert-messages';
import DeleteIcon from '@mui/icons-material/Delete';
import BarcodeHelper from 'helpers/BarcodeHelper';
import useBarcodeScanner from 'hooks/useBarcodeScanner';
import { ITEM_TYPES } from 'const';
import ShopService from 'services/ShopService';
import SelectShopsDialog from './SelectShopsDialog';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import CustomMenuItem from 'components/utils/CustomComponents/CustomMenuItem';
import AddCategoryDialog from './AddCategoryDialog';
import ShopsHelper from 'helpers/ShopsHelper';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import EditIcon from '@mui/icons-material/Edit';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import PriceCategoryService from 'services/PriceCategoryService';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner';
import { InventoryContext } from 'Context/InventoryContext';
import ItemAddonService from 'services/ItemAddonService';
import { useTranslation } from 'react-i18next';
import NumberField from 'components/library/NumberField';
import DescriptionField from 'components/utils/CustomComponents/DescriptionField';

export default function AddItemDialog(props) {
  const DELTA_TYPE = {
    LESS: 'less',
    MORE: 'more',
  };

  const { t: tCommon } = useTranslation('common');
  const { t: tPopup } = useTranslation('popup');
  const { handleClose, onSuccess, initialName, initialEan, initialBarcode } = props;
  const {
    getPriceCategories,
    getItemPriceCategories,
    getItemAddonMappings,
    getChargeGroups,
    getCategories,
    getProducts,
    priceCategories,
    chargeGroups,
    products: items,
    categories,
    setProducts,
    setCategories,
    setItemAddonMappings,
    setItemPriceCategories,
  } = useContext(InventoryContext);

  const { shop } = useContext(ShopContext);
  const { postAlertMessage } = useContext(AlertMessagesContext);

  const rawInput = (initialName || '').trim();
  const rawEan = (initialEan || initialBarcode || '').trim();
  const isBarcode = Boolean(
    rawEan ||
    (rawInput && (/^\d{3,}$/.test(rawInput) || (/^[A-Za-z0-9_-]{4,}$/.test(rawInput) && /\d/.test(rawInput))))
  );

  const prefilledBarcode = rawEan || (isBarcode ? rawInput : '');
  const prefilledName = isBarcode && !rawEan ? '' : rawInput;

  // const [plu, setPlu] = useState('');
  const [name, setName] = useState(prefilledName);
  const [internalName, setInternalName] = useState('');
  const [otherNames, setOtherNames] = useState([{ name: '', option: '' }]);
  const [unit, setUnit] = useState('Pcs');
  const [price, setPrice] = useState('');
  const [cost, setCost] = useState('');
  const [kgRation, setKgRatio] = useState('');
  const [kgPrice, setKgPrice] = useState('');
  const [leastPrice, setLeastPrice] = useState('');
  const [mrp, setMrp] = useState('');
  const [cess, setCess] = useState(0);
  const [stock, setStock] = useState('');
  const [ean, setEan] = useState(prefilledBarcode);
  const [tax, setTax] = useState(0);
  const [category, setCategory] = useState('');
  const [extenalId, setExtenalId] = useState('');
  const [sync, setSync] = useState(false);
  const [available, setAvailable] = useState(true);
  const [availableOnCart, setAvailableOnCart] = useState(true);
  const [order, setOrder] = useState(null);
  const [type, setType] = useState(props.initialType || ITEM_TYPES.SERVICE);
  const [details, setDetails] = useState({
    sub_items: [],
  });
  const [subItem, setSubItem] = useState({});
  const [hsn, setHsn] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isShowSelectShopsDialog, setIsShowSelectShopsDialog] = useState(false);
  const [isShowAddCategoryDialog, setShowAddCategoryDialog] = useState(false);
  const [description, setDescription] = useState(null);
  const [selectedDays, setSelectedDays] = useState([]);
  const [timeRanges, setTimeRanges] = useState([{ from: null, to: null }]);
  const [priceCategoryItems, setPriceCategoryItems] = useState([]);
  const [selectedPriceCategoryItem, setSelectedPriceCategoryItem] = useState({});
  const [itemAddons, setItemAddons] = useState([]);
  const [selectedAddon, setSelectedAddon] = useState({});
  const [chargeGroup, setChargeGroup] = useState([]);
  const [tags, setTags] = useState([{ key: '', value: '' }]);
  const [productOptions, setProductOptions] = useState([]);
  const [selectedProductOption, setSelectedProductOption] = useState({ quantity_ratio: 1 });
  const [addonDeltaType, setAddonDeltaType] = useState(DELTA_TYPE.MORE);
  const [showMore, setShowMore] = useState(Boolean(prefilledBarcode));

  useEffect(() => {
    if (ean && String(ean).trim() !== '' && String(ean).trim() !== 'nil') {
      setShowMore(true);
    }
  }, [ean]);

  const priceCategorySectionRef = useRef();
  const addonSectionRef = useRef();

  const nameInputRef = useRef(null);

  useEffect(() => {
    const rawEan = (initialEan || initialBarcode || '').trim();
    if (rawEan) {
      setEan(rawEan);
    }
  }, [initialBarcode, initialEan]);

  useEffect(() => {
    const rawInput = (initialName || '').trim();
    if (rawInput) {
      setName((prev) => (prev ? prev : rawInput));
    }
  }, [initialName]);

  useEffect(() => {
    if (prefilledBarcode && !prefilledName && nameInputRef.current) {
      setTimeout(() => {
        nameInputRef.current?.focus();
      }, 150);
    }
  }, [prefilledBarcode, prefilledName]);

  const duplicateBarcodeItem = useMemo(() => {
    return BarcodeHelper.findDuplicateBarcodeItem(ean, items);
  }, [ean, items]);

  useBarcodeScanner({
    isCapture: true,
    minBufferLength: 2,
    onScan: (scannedCode) => {
      setShowMore(true);
      setName((prev) => {
        if (!prev) return '';
        if (prev === scannedCode || prev === String(scannedCode).slice(0, 1)) {
          return '';
        }
        if (prev.endsWith(scannedCode)) {
          return prev.slice(0, -scannedCode.length).trim();
        }
        return prev;
      });
      setPrice((prev) => {
        if (prev && (String(prev) === scannedCode || String(prev) === String(scannedCode).slice(0, 1))) {
          return '';
        }
        return prev;
      });
      setCost((prev) => {
        if (prev && (String(prev) === scannedCode || String(prev) === String(scannedCode).slice(0, 1))) {
          return '';
        }
        return prev;
      });
      setEan(scannedCode);
      const existing = BarcodeHelper.findDuplicateBarcodeItem(scannedCode, items);
      if (existing) {
        postAlertMessage({
          text: `Warning: Barcode "${scannedCode}" already exists for product: "${existing.name}" (PLU: ${existing.plu})`,
          type: 'warning',
        });
      }
    },
    deps: [items, postAlertMessage],
  });

  const scrollTo = (ref) => {
    ref.current?.scrollIntoView({ behavior: 'smooth' });
  };

  const removeSubItem = (subItem) => {
    const newSubItems = details.sub_items.filter((item) => item.item_id !== subItem.item_id);
    const calculatedCost = calculateCostFromSubItems(newSubItems);

    const updatedDetails = {
      ...details,
      sub_items: newSubItems,
    };

    setDetails(updatedDetails);
    setCost(calculatedCost);
  };

  const addSubItem = () => {
    const newSubItems = [...details.sub_items, subItem];
    const calculatedCost = calculateCostFromSubItems(newSubItems);

    setDetails({ ...details, sub_items: newSubItems });
    setCost(calculatedCost);
    setSubItem({});
  };

  const onAddItemButtonClicked = async () => {
    if (await shouldShowSelectOtherShopsDialog()) {
      setIsShowSelectShopsDialog(true);
      return;
    }
    await handleAddItem();
  };

  const shouldShowSelectOtherShopsDialog = async () => {
    if (!ShopsHelper.hasProAccess(shop)) {
      return false;
    }

    const localPreference = localStorage.getItem(STORAGE_KEYS.DONT_SHOW_OTHER_SHOPS_ON_ITEM_EDIT);
    if (localPreference && localPreference === String(true)) {
      return false;
    }

    setIsLoading(true);
    const shops = await ShopService.getShops();
    setIsLoading(false);
    return shops.length > 1;
  };

  const openCreateCategoryDialog = () => {
    setShowAddCategoryDialog(true);
  };

  const closeCreateCategoryDialog = () => {
    setShowAddCategoryDialog(false);
  };

  const onCreateCategory = async (category) => {
    if (category) {
      setCategories((prev) => [...prev, category]);
    } else {
      setIsLoading(true);
      await getCategories({ useCache: false });
      setIsLoading(false);
    }
  };

  const handleTimeRangeChange = (index, field, value) => {
    setTimeRanges((prev) => {
      const arr = [...prev];
      arr[index] = { ...arr[index], [field]: value };
      return arr;
    });
  };

  const addRangeRow = () => {
    setTimeRanges((prev) => [...prev, { from: null, to: null }]);
  };

  const removeRangeRow = (index) => {
    setTimeRanges((prev) => prev.filter((_, i) => i !== index));
  };

  const handleDayChange = (event, newDays) => {
    setSelectedDays(newDays);
  };

  const tagsObject = (tagsArray) => {
    const obj = {};
    tagsArray.forEach(({ key, value }) => {
      const k = (key ?? '').trim();
      if (!k) return;

      const v = value ?? '';
      if (Object.prototype.hasOwnProperty.call(obj, k)) {
        if (Array.isArray(obj[k])) {
          obj[k].push(v);
        } else {
          obj[k] = [obj[k], v];
        }
      } else {
        obj[k] = v;
      }
    });
    return obj;
  };

  const serializeOtherNames = (arr) => {
    return arr
      .filter((item) => item.name.trim())
      .map((item) => {
        if (item.option.trim()) {
          return `${item.name.trim()} | Option: ${item.option.trim()}`;
        }
        return item.name.trim();
      })
      .join('\n');
  };

  const handleAddItem = async (shopIds) => {
    if (duplicateBarcodeItem) {
      postAlertMessage({
        text: `Barcode "${ean.trim()}" already exists for product: "${duplicateBarcodeItem.name}" (PLU: ${duplicateBarcodeItem.plu}). Please use a unique barcode.`,
        type: 'failed',
      });
      return;
    }

    const hasAnySchedule = selectedDays.length > 0 || timeRanges.some(({ from, to }) => from != null || to != null);
    const tagsObj = tagsObject(tags);

    let daysStr = null;
    let timeRangesStr = null;

    if (hasAnySchedule) {
      for (const { from, to } of timeRanges) {
        if (!from || !to) {
          postAlertMessage({
            text: tPopup('Please fill in both the Start Time and End Time.'),
            type: 'failed',
          });
          return;
        }
        if (from >= to) {
          postAlertMessage({
            text: tPopup('Start Time must be earlier than End Time.'),
            type: 'failed',
          });
          return;
        }
      }

      const schedulePayload = timeRanges.map(({ from, to }) => {
        const pad = (n) => String(n).padStart(2, '0');
        const fH = pad(from.getHours()),
          fM = pad(from.getMinutes());
        const tH = pad(to.getHours()),
          tM = pad(to.getMinutes());
        return `${fH}:${fM}-${tH}:${tM}`;
      });

      daysStr = selectedDays.length ? selectedDays.join(',') : null;
      timeRangesStr = schedulePayload.length ? schedulePayload.join(',') : null;
    }

    const data = {
      category: category,
      name,
      internal_name: internalName,
      other_names: serializeOtherNames(otherNames),
      unit,
      price,
      cess: cess ? cess : 0,
      mrp: mrp ? mrp : 0,
      cost: cost ? cost : 0,
      stock: stock ? stock : 0,
      ean: ean ? ean : 'nil',
      tax: tax ? tax : 0,
      is_available: available ? true : undefined,
      is_available_on_cart: availableOnCart ? true : undefined,
      sync_enabled: sync ? true : undefined,
      external_item_id: extenalId ?? null,
      order,
      least_price: leastPrice ? leastPrice : 0,
      details,
      type,
      description,
      hsn,
      available_days: daysStr,
      available_time_range: timeRangesStr,
      config: {
        tags: tagsObj,
        product_options: productOptions,
      },
      kg_ratio: kgRation ? kgRation : null,
      charge_groups: chargeGroup,
    };

    if (selectedProductOption?.label) {
      const finalOption = {
        ...selectedProductOption,
        quantity_ratio:
          selectedProductOption.quantity_ratio === '' || selectedProductOption.quantity_ratio === undefined
            ? 1
            : selectedProductOption.quantity_ratio,
      };
      const existingOptions = data.config.product_options || [];
      const filteredOptions = existingOptions.filter(
        (opt) => String(opt.label) !== String(finalOption.label) || String(opt.price) !== String(finalOption.price)
      );
      data.config.product_options = [...filteredOptions, finalOption];
    }

    if (shopIds) {
      data.shop_ids = shopIds;
    }
    const isFreePlan = ShopsHelper.isFreePlan(shop);
    if (isFreePlan && (items?.length || 0) >= 100) {
      postAlertMessage({
        text: 'Product limit reached for Free Plan (max 100 products).',
        type: 'failed',
      });
      return;
    }
    setIsLoading(true);
    try {
      const resp = await ItemService.addItem(data);
      let enrichedItem = resp;
      if (resp) {
        enrichedItem = {
          ...data,
          ...resp,
          ean:
            ean && String(ean).trim() !== '' && String(ean).trim() !== 'nil'
              ? String(ean).trim()
              : resp?.ean && String(resp.ean).trim() !== 'nil'
              ? String(resp.ean).trim()
              : data.ean && data.ean !== 'nil'
              ? data.ean
              : null,
          type: resp?.type || data.type || ITEM_TYPES.SERVICE,
        };
        setProducts((prev) => [enrichedItem, ...(prev || []).filter((p) => p.id !== resp.id)]);
        if (priceCategoryItems.length > 0) {
          const priceCategoriesResp = await PriceCategoryService.createItemPriceCategories(
            resp.id,
            priceCategoryItems.map((i) => ({ ...i, item_id: resp.id }))
          );
          setItemPriceCategories((prev) => [...prev, ...priceCategoriesResp]);
        }
        if (itemAddons.length > 0) {
          const addonResp = await ItemAddonService.createItemAddonMappings(
            resp.id,
            itemAddons.map((i) => ({ ...i, item_id: resp.id }))
          );
          setItemAddonMappings((prev) => [...prev, ...addonResp]);
        }
        getProducts({ useCache: false }).catch(() => {});
      } else {
        getProducts({ useCache: false });
      }

      postAlertMessage({
        text: tPopup('Item created successfully'),
        type: 'success',
      });
      if (onSuccess) {
        onSuccess(enrichedItem || resp);
      }
      handleClose();
    } catch (error) {
      postAlertMessage({ text: error.message, type: 'failed' });
    }
    setIsLoading(false);
  };

  const onOtherShopsSelected = async (shopIds) => {
    setIsShowSelectShopsDialog(false);
    await handleAddItem(shopIds);
  };

  const closeOtherShopsSelectionDialog = () => {
    setIsShowSelectShopsDialog(false);
  };

  // const checkPluIsAvailable = (value) => {
  //   setPlu(value);
  //   setError(!items.find((_item) => _item.plu === Number(value)));
  // };
  // const handleSuggestPlu = async () => {
  //   try {
  //     const resp = await ItemService.getHighestPlu();
  //     setPlu(String(resp?.highest_plu + 1));
  //   } catch (error) {
  //     setPlu(String(itemCount + 1));
  //   }
  // };

  const handleEditCategoryItem = (categoryItem) => {
    if (Object.keys(selectedPriceCategoryItem).length > 0) {
      postAlertMessage({
        text: tPopup('Please save or cancel the current edits before editing another price category.'),
        type: 'failed',
      });
      return;
    }
    setSelectedPriceCategoryItem(categoryItem);
    handleDltCategoryItem(categoryItem);
  };

  const handleDltCategoryItem = (categoryItem) => {
    setPriceCategoryItems((prev) =>
      prev.filter(
        (item) =>
          item.category_id !== categoryItem.category_id ||
          item.price !== categoryItem.price ||
          item.minimum_quantity !== categoryItem.minimum_quantity
      )
    );
  };

  const handleEditProductOption = (option) => {
    if (
      selectedProductOption?.label ||
      selectedProductOption?.price ||
      (selectedProductOption?.quantity_ratio !== undefined && selectedProductOption?.quantity_ratio !== 1)
    ) {
      postAlertMessage({
        text: 'Please save or cancel the current edits before editing another product option.',
        type: 'failed',
      });
      return;
    }
    setSelectedProductOption(option);
    handleDltProductOption(option);
  };

  const handleDltProductOption = (option) => {
    setProductOptions((prev) =>
      prev.filter((item) => String(item.label) !== String(option.label) || String(item.price) !== String(option.price))
    );
  };

  const handleAddProductOption = (option) => {
    const finalOption = {
      ...option,
      quantity_ratio: option.quantity_ratio === '' || option.quantity_ratio === undefined ? 1 : option.quantity_ratio,
    };
    setProductOptions((prev) => [...prev, finalOption]);
    setSelectedProductOption({ quantity_ratio: 1 });
  };

  const handleAddCategoryItem = (categoryItem) => {
    setPriceCategoryItems((prev) => [...prev, categoryItem]);
    setSelectedPriceCategoryItem({});
  };

  const handleEditAddon = (addon) => {
    if (Object.keys(selectedAddon).length > 0) {
      postAlertMessage({
        text: tPopup('Please save or cancel the current edits before editing another addon.'),
        type: 'failed',
      });
      return;
    }
    scrollTo(addonSectionRef);
    if (addon.price_delta >= 0) {
      setAddonDeltaType(DELTA_TYPE.MORE);
    } else {
      setAddonDeltaType(DELTA_TYPE.LESS);
    }
    setSelectedAddon({ ...addon, price_delta: Math.abs(addon.price_delta) });
    handleDltAddon(addon);
  };

  const handleDltAddon = (addon) => {
    setItemAddons((prev) =>
      prev.filter((item) => item.addon_item_id !== addon.addon_item_id || item.price_delta !== addon.price_delta)
    );
  };

  const handleAddAddon = (categoryItem) => {
    const newAddon = {
      ...categoryItem,
      price_delta:
        addonDeltaType === DELTA_TYPE.MORE ? Math.abs(categoryItem.price_delta) : -Math.abs(categoryItem.price_delta),
    };
    setItemAddons((prev) => [...prev, newAddon]);
    setSelectedAddon({});
  };

  const handleChange = (index, field, value) => {
    const updated = [...tags];
    updated[index][field] = value;
    setTags(updated);
  };

  const handleAddRow = () => {
    setTags([...tags, { key: '', value: '' }]);
  };

  const handleDeleteRow = (index) => {
    setTags(tags.filter((_, i) => i !== index));
  };

  const getKeySuggestions = (input) => {
    return (PRODUCTS_TAG_SUGGESTIONS || [])
      .map((s) => s.key)
      .filter((k) => k.toLowerCase().includes((input || '').toLowerCase()));
  };

  const getValueSuggestions = (key) => {
    const found = (PRODUCTS_TAG_SUGGESTIONS || []).find((s) => s.key === key);
    return found ? found.values : [];
  };

  const handleAddOtherNameRow = () => {
    setOtherNames([...otherNames, { name: '', option: '' }]);
  };

  const handleRemoveOtherNameRow = (index) => {
    const updated = otherNames.filter((_, i) => i !== index);
    setOtherNames(updated.length ? updated : [{ name: '', option: '' }]);
  };

  const handleOtherNameChange = (index, field, value) => {
    const updated = [...otherNames];
    updated[index][field] = value;
    setOtherNames(updated);
  };

  const calculateCostFromSubItems = useCallback(
    (subItems) => {
      if (!subItems || subItems.length === 0) return 0;

      let totalCost = 0;
      subItems.forEach((subItem) => {
        const item = (items || []).find((i) => i.id === subItem.item_id);
        if (item && item.cost && subItem.fraction) {
          const itemCost = Number(item.cost) || 0;
          const fraction = Number(subItem.fraction) || 0;
          totalCost += itemCost * fraction;
        }
      });

      return Math.round(totalCost * 100) / 100;
    },
    [items]
  );

  useEffect(() => {
    if (details?.sub_items && details?.sub_items.length > 0) {
      const calculatedCost = calculateCostFromSubItems(details.sub_items);
      if (calculatedCost > 0 && calculatedCost !== cost) {
        setCost(calculatedCost);
      }
    }
    //eslint-disable-next-line
  }, [details?.sub_items, calculateCostFromSubItems]);

  useEffect(() => {
    getProducts();
    getCategories();
    if (ShopsHelper.hasPremiumAccess(shop)) {
      getPriceCategories();
      getItemPriceCategories();
      getItemAddonMappings();
      getChargeGroups();
    }
  }, [
    getProducts,
    getCategories,
    getPriceCategories,
    getItemPriceCategories,
    getItemAddonMappings,
    getChargeGroups,
    shop,
  ]);

  return (
    <>
      <div className={styles.popUp}>
        <div className={styles.contentWrapper}>
          <div className={styles.headSec}>
            <h2 className={styles.editTitle}>{tCommon('Create Item')}</h2>
            <IconButton onClick={handleClose} size="small" style={{ color: '#5f6368' }}>
              <CloseIcon />
            </IconButton>
          </div>
          <div className={styles.inputSec}>
            <Grid container className={styles.inputRow} alignItems="top" spacing={1}>
              <Grid item xs={12} sm={6}>
                <TextField
                  label={tCommon('Item Name')}
                  variant="outlined"
                  size="small"
                  name="name"
                  value={name}
                  inputRef={nameInputRef}
                  onChange={(e) => setName(e.target.value)}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label={tCommon('Item Category')}
                  select
                  name="category"
                  size="small"
                  variant="outlined"
                  color="primary"
                  value={category}
                  onChange={(e) => setCategory(e.target.value)}
                  fullWidth
                  SelectProps={{
                    MenuProps: {
                      getContentAnchorEl: null,
                      anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
                      transformOrigin: { vertical: 'top', horizontal: 'left' },
                      PaperProps: {
                        style: {
                          maxHeight: 400,
                          marginTop: 5,
                        },
                      },
                      style: { zIndex: 10001 },
                    },
                  }}
                >
                  {(categories || []).map((category) => (
                    <MenuItem value={category.id}>{category.name}</MenuItem>
                  ))}
                  <CustomMenuItem onClick={openCreateCategoryDialog}>
                    <AddCircleOutlineIcon fontSize="large" style={{ marginLeft: 5 }} />{' '}
                    <p className={styles.normalText}>{tCommon('Create New Category')}</p>
                  </CustomMenuItem>
                </TextField>
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label={tCommon('Unit')}
                  select
                  name="Unit"
                  size="small"
                  variant="outlined"
                  color="primary"
                  value={unit}
                  onChange={(e) => setUnit(e.target.value)}
                  fullWidth
                  SelectProps={{
                    MenuProps: {
                      getContentAnchorEl: null,
                      anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
                      transformOrigin: { vertical: 'top', horizontal: 'left' },
                      PaperProps: {
                        style: {
                          maxHeight: 400,
                          marginTop: 5,
                        },
                      },
                      style: { zIndex: 10001 },
                    },
                  }}
                >
                  {(shop?.units?.split(',') || []).map((unit) => {
                    return <MenuItem value={unit}>{unit}</MenuItem>;
                  })}
                </TextField>
              </Grid>
              <Grid item xs={12} sm={6}>
                <NumberField
                  label={tCommon('Price')}
                  className={styles.numberInput}
                  name="price"
                  value={price}
                  onChange={(e) => {
                    const txt = e.target.value;
                    if (txt === '') {
                      setPrice('');
                      setKgPrice('');
                    } else {
                      const priceVal = parseFloat(txt) || 0;
                      setPrice(ShopsHelper.getAmountFormatted(shop, priceVal));
                      if (kgRation && priceVal) {
                        setKgPrice((priceVal * parseFloat(kgRation)).toString());
                      } else {
                        setKgPrice(txt);
                        setKgRatio(1);
                      }
                    }
                  }}
                  fullWidth
                />
              </Grid>


              <Grid item xs={12}>
                <Grid className={styles.subContainerEssentials} spacing={1} alignItems="center">
                  <Grid item xs={12} sm={4}>
                    <h3 className={styles.inputLabelCompact}>{tCommon('Item Type')}</h3>
                  </Grid>
                  <Grid item xs={12}>
                    <NumberField
                      select
                      value={type}
                      variant="outlined"
                      size="small"
                      onChange={(e) => {
                        let type = e.target.value;
                        setType(e.target.value);
                        if (type === ITEM_TYPES.INVENTORY) {
                          setDetails({ ...details, sub_items: [] });
                        } else {
                          setStock(0);
                        }
                      }}
                      fullWidth
                      SelectProps={{
                        MenuProps: {
                          anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
                          transformOrigin: { vertical: 'top', horizontal: 'left' },
                          PaperProps: {
                            style: {
                              maxHeight: 400,
                              marginTop: 5,
                            },
                          },
                          style: { zIndex: 10001 },
                        },
                      }}
                    >
                      <MenuItem value={ITEM_TYPES.INVENTORY}>Inventory</MenuItem>
                      <MenuItem value={ITEM_TYPES.COMBO}>Combo</MenuItem>
                      <MenuItem value={ITEM_TYPES.PRODUCTION}>Production</MenuItem>
                      <MenuItem value={ITEM_TYPES.SERVICE}>Service</MenuItem>
                    </NumberField>
                  </Grid>

                  {/* ITEM_TYPES.INVENTORY Stock - Show inline with essentials if inventory */}
                  {type === ITEM_TYPES.INVENTORY && (
                    <Grid container alignItems={'center'} mt={1}>
                      <Grid item xs={12} sm={4}>
                        <h3 className={styles.inputLabelCompact}>{tCommon('Stock')}</h3>
                      </Grid>
                      <Grid item xs={12} sm={8}>
                        <NumberField
                          label={tCommon('Stock')}
                          variant="outlined"
                          size="small"
                          name="stock"
                          value={stock}
                          onChange={(e) => setStock(e.target.value)}
                          fullWidth
                        />
                      </Grid>
                    </Grid>
                  )}

                  {(type === ITEM_TYPES.COMBO || type === ITEM_TYPES.PRODUCTION) && (
                    <Grid container mt={2} className={styles.subContainer} pb={2}>
                      <Grid container className={styles.pillHeaderContainer}>
                        <h3 className={styles.pillHeaderText}>Item Type Actions</h3>
                      </Grid>

                      {/* ITEM_TYPES.COMBO */}
                      {type === ITEM_TYPES.COMBO && (
                        <Grid container spacing={2} pt={2} className={styles.inputRow} alignItems="center">
                          <Grid item xs={12} sm={6}>
                            <h3 className={styles.inputSubLabel}>{tCommon('Combo Items')}</h3>
                            <Autocomplete
                              fullWidth
                              size="small"
                              openOnFocus
                              disablePortal
                              value={(items || []).find((item) => item.id === subItem?.item_id) || null}
                              onChange={(event, newValue) => {
                                if (newValue) {
                                  setSubItem({ ...subItem, item_id: newValue.id, name: newValue.name });
                                } else {
                                  setSubItem({ ...subItem, item_id: null, name: '' });
                                }
                              }}
                              options={Array.isArray(items) ? items : items?.data || []}
                              getOptionLabel={(option) => {
                                if (typeof option === 'string') return option;
                                if (!option) return '';
                                return option.plu ? `${option.plu} - ${option.name || ''}` : option.name || '';
                              }}
                              getOptionSelected={(option, value) => option.id === value?.id}
                              filterOptions={(options, { inputValue }) => {
                                const search = (inputValue || '').toLowerCase();
                                return options.filter((option) => {
                                  const name = (option?.name || '').toLowerCase();
                                  const plu = (option?.plu || '').toString().toLowerCase();
                                  const ean = (option?.ean || '').toString().toLowerCase();
                                  return (
                                    name.includes(search) ||
                                    plu.includes(search) ||
                                    (ean !== 'nil' && ean.includes(search))
                                  );
                                });
                              }}
                              PopperProps={{ style: { zIndex: 10001 } }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label={tCommon('Search by items')}
                                  variant="outlined"
                                  size="small"
                                  fullWidth
                                />
                              )}
                            />
                          </Grid>
                          <Grid item xs={6} sm={3}>
                            <h3 className={styles.inputSubLabel}>{tCommon('Fraction')}</h3>
                            <NumberField
                              label={tCommon('Fraction')}
                              className={styles.numberInput}
                              name="fraction"
                              value={subItem?.fraction}
                              onChange={(e) => {
                                const txt = e.target.value;
                                if (txt === '') {
                                  setSubItem((prev) => ({ ...prev, fraction: '' }));
                                } else {
                                  const fraction = parseFloat(txt) || 0;
                                  setSubItem((prev) => ({ ...prev, fraction }));
                                }
                              }}
                              fullWidth
                            />
                          </Grid>

                          <Grid item xs={6} sm={3}>
                            <h3 className={styles.inputSubLabel}>{tCommon('Save')}</h3>
                            <Button
                              fullWidth
                              variant="contained"
                              disabled={!subItem.fraction || subItem?.fraction === '' || !subItem.item_id}
                              onClick={addSubItem}
                            >
                              <LibraryAddIcon />
                            </Button>
                          </Grid>

                          <Grid item container xs={12}>
                            <>
                              {(details.sub_items || []).map((subItem) => {
                                return (
                                  <React.Fragment key={subItem.item_id}>
                                    <Grid item xs={6} className={styles.subLabel}>
                                      {subItem?.name}
                                    </Grid>
                                    <Grid item xs={3} className={styles.subLabel}>
                                      {subItem?.fraction || 0}
                                    </Grid>
                                    <Grid item xs={3} className={styles.subLabel}>
                                      <Button
                                        fullWidth
                                        variant="contained"
                                        onClick={() => {
                                          removeSubItem(subItem);
                                        }}
                                      >
                                        <DeleteIcon />
                                      </Button>
                                    </Grid>
                                  </React.Fragment>
                                );
                              })}
                            </>
                          </Grid>
                        </Grid>
                      )}
                      {/* ITEM_TYPES.PRODUCTION  */}
                      {type === ITEM_TYPES.PRODUCTION && (
                        <>
                          <Grid item container className={styles.inputRow} p={1} alignItems="center">
                            <Grid item xs={4} sm={4} className={styles.inputLabelContainer}>
                              <h3 className={styles.inputLabel}>{tCommon('Stock')}</h3>
                            </Grid>
                            <Grid item xs={8} sm={8}>
                              <NumberField
                                label={tCommon('Stock')}
                                className={styles.numberInput}
                                name="stock"
                                value={stock}
                                onChange={(e) => setStock(e.target.value)}
                                fullWidth
                              />
                            </Grid>
                          </Grid>
                          <Grid container spacing={2} className={styles.inputRow} alignItems="center">
                            <Grid item xs={12} sm={6} container>
                              <h3 className={styles.inputSubLabel}>{tCommon('Sub Items')}</h3>
                              <Autocomplete
                                fullWidth
                                size="small"
                                openOnFocus
                                disablePortal
                                value={(items || []).find((item) => item.id === subItem?.item_id) || null}
                                onChange={(event, newValue) => {
                                  if (newValue) {
                                    setSubItem({ ...subItem, item_id: newValue.id, name: newValue.name });
                                  } else {
                                    setSubItem({ ...subItem, item_id: null, name: '' });
                                  }
                                }}
                                options={Array.isArray(items) ? items : items?.data || []}
                                getOptionLabel={(option) => {
                                  if (typeof option === 'string') return option;
                                  if (!option) return '';
                                  return option.plu ? `${option.plu} - ${option.name || ''}` : option.name || '';
                                }}
                                getOptionSelected={(option, value) => option.id === value?.id}
                                filterOptions={(options, { inputValue }) => {
                                  const search = (inputValue || '').toLowerCase();
                                  return options.filter((option) => {
                                    const name = (option?.name || '').toLowerCase();
                                    const plu = (option?.plu || '').toString().toLowerCase();
                                    const ean = (option?.ean || '').toString().toLowerCase();
                                    return (
                                      name.includes(search) ||
                                      plu.includes(search) ||
                                      (ean !== 'nil' && ean.includes(search))
                                    );
                                  });
                                }}
                                PopperProps={{ style: { zIndex: 10001 } }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    label={tCommon('Search by items')}
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                  />
                                )}
                              />
                            </Grid>

                            <Grid item xs={6} sm={3} container>
                              <h3 className={styles.inputSubLabel}>{tCommon('Fraction')}</h3>
                              <NumberField
                                label={tCommon('Fraction')}
                                className={styles.numberInput}
                                name="fraction"
                                value={subItem?.fraction}
                                onChange={(e) => {
                                  const txt = e.target.value;
                                  if (txt === '') {
                                    setSubItem((prev) => ({ ...prev, fraction: '' }));
                                  } else {
                                    const fraction = parseFloat(txt) || 0;
                                    setSubItem((prev) => ({ ...prev, fraction }));
                                  }
                                }}
                                fullWidth
                              />
                            </Grid>
                            <Grid item xs={6} sm={3} container>
                              <h3 className={styles.inputSubLabel}>{tCommon('Save')}</h3>
                              <Button
                                fullWidth
                                variant="contained"
                                disabled={!subItem.fraction || subItem?.fraction === '' || !subItem.item_id}
                                onClick={addSubItem}
                              >
                                <LibraryAddIcon />
                              </Button>
                            </Grid>

                            <Grid item container xs={12} pt={1} spacing={1}>
                              <>
                                {(details.sub_items || []).map((subItem) => {
                                  return (
                                    <React.Fragment key={subItem.item_id}>
                                      <Grid item xs={6} className={styles.subLabel}>
                                        {subItem?.name}
                                      </Grid>
                                      <Grid item xs={3} className={styles.subLabel}>
                                        {subItem?.fraction || 0}
                                      </Grid>
                                      <Grid item xs={3}>
                                        <Button
                                          variant="contained"
                                          onClick={() => {
                                            removeSubItem(subItem);
                                          }}
                                        >
                                          <DeleteIcon />
                                        </Button>
                                      </Grid>
                                    </React.Fragment>
                                  );
                                })}
                              </>
                            </Grid>
                          </Grid>
                        </>
                      )}
                    </Grid>
                  )}
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <Button
                  fullWidth
                  onClick={() => setShowMore(!showMore)}
                  className={styles.showMoreToggle}
                  endIcon={showMore ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                >
                  {showMore ? tCommon('Show Less Options') : tCommon('Show More Options (Tax, Extra Names, etc.)')}
                </Button>
              </Grid>

              {showMore && (
                <>
                  <Grid item xs={12}>
                    <TextField
                      label={tCommon('Internal Name')}
                      variant="outlined"
                      size="small"
                      name="internalName"
                      value={internalName}
                      onChange={(e) => setInternalName(e.target.value)}
                      fullWidth
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <h3 className={styles.inputLabel}>{tCommon('Other Names')}</h3>
                    {otherNames.map((item, index) => (
                      <Grid container spacing={1} key={index} alignItems="center" style={{ marginBottom: 8 }}>
                        <Grid item xs={6} sm={8}>
                          <TextField
                            label={tCommon('Name')}
                            variant="outlined"
                            size="small"
                            value={item.name}
                            onChange={(e) => handleOtherNameChange(index, 'name', e.target.value)}
                            fullWidth
                          />
                        </Grid>
                        <Grid item xs={5} sm={3}>
                          <TextField
                            label={`${tCommon('Option')} (${tCommon('Optional')})`}
                            variant="outlined"
                            size="small"
                            value={item.option}
                            onChange={(e) => handleOtherNameChange(index, 'option', e.target.value)}
                            fullWidth
                          />
                        </Grid>
                        <Grid item xs={1} sm={1}>
                          <IconButton onClick={() => handleRemoveOtherNameRow(index)} size="small" color="secondary">
                            <DeleteIcon />
                          </IconButton>
                        </Grid>
                      </Grid>
                    ))}
                    <Button
                      startIcon={<AddCircleIcon />}
                      onClick={handleAddOtherNameRow}
                      size="small"
                      variant="outlined"
                      color="primary"
                    >
                      {tCommon('Add Other Name')}
                    </Button>
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <NumberField
                      label={tCommon('USP Kg Ratio')}
                      className={styles.numberInput}
                      name="kgRation"
                      value={kgRation}
                      onChange={(e) => {
                        const txt = e.target.value;
                        setKgRatio(txt);
                        const ratio = parseFloat(txt);
                        const priceVal = parseFloat(price) || 0;
                        if (ratio && priceVal) {
                          setKgPrice((priceVal * ratio).toString());
                        } else {
                          setKgPrice('');
                        }
                      }}
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <NumberField
                      label={tCommon('Kg Price')}
                      className={styles.numberInput}
                      name="kgPrice"
                      value={kgPrice}
                      onChange={(e) => {
                        const txt = e.target.value;
                        setKgPrice(txt);
                        const kgPriceVal = parseFloat(txt);
                        const priceVal = parseFloat(price) || 0;
                        if (kgPriceVal && priceVal) {
                          setKgRatio(parseFloat((kgPriceVal / priceVal).toFixed(2)));
                        } else {
                          setKgRatio('');
                        }
                      }}
                      fullWidth
                    />
                  </Grid>
                  {!ShopsHelper.isFreePlan(shop) && (
                    <>
                      <Grid item xs={12} sm={6}>
                        <NumberField
                          label={tCommon('Cost')}
                          className={styles.numberInput}
                          name="cost"
                          value={cost}
                          onChange={(e) => {
                            const txt = e.target.value;
                            if (txt === '') {
                              setCost('');
                            } else {
                              const cost = parseFloat(txt) || 0;
                              setCost(ShopsHelper.getAmountFormatted(shop, cost));
                            }
                          }}
                          fullWidth
                        />
                        {(type === ITEM_TYPES.COMBO || type === ITEM_TYPES.PRODUCTION) &&
                          details?.sub_items &&
                          details?.sub_items.length > 0 && (
                            <span className={styles.note} style={{ fontSize: '0.75rem', color: '#666' }}>
                              Cost calculated from sub-items
                            </span>
                          )}
                      </Grid>
                    </>
                  )}

                  <Grid item xs={12} sm={6}>
                    <NumberField
                      label={tCommon('MRP')}
                      name="mrp"
                      value={mrp}
                      onChange={(e) => {
                        const txt = e.target.value;
                        if (txt === '') {
                          setMrp('');
                        } else {
                          const mrp = parseFloat(txt) || 0;
                          setMrp(ShopsHelper.getAmountFormatted(shop, mrp));
                        }
                      }}
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <NumberField
                      label={tCommon('Least Price (Optional)')}
                      name="leastPrice"
                      value={leastPrice}
                      onChange={(e) => setLeastPrice(e.target.value)}
                      fullWidth
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <TextField
                      label={tCommon('Product Barcode')}
                      variant="outlined"
                      size="small"
                      fullWidth
                      name="ean"
                      value={ean}
                      onChange={(e) => setEan(e.target.value)}
                      error={Boolean(duplicateBarcodeItem)}
                      helperText={
                        duplicateBarcodeItem
                          ? `Barcode already assigned to: ${duplicateBarcodeItem.name} (PLU: ${duplicateBarcodeItem.plu})`
                          : ''
                      }
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <Tooltip title="Barcode Scan Supported">
                              <QrCodeScannerIcon style={{ fontSize: '18px', color: duplicateBarcodeItem ? '#d32f2f' : '#2563eb' }} />
                            </Tooltip>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  {(!chargeGroup || (Array.isArray(chargeGroup) && chargeGroup.length === 0)) && (
                    <>
                      <Grid item xs={12} sm={6}>
                        <NumberField
                          label={tCommon('Tax(%)')}
                          className={styles.numberInput}
                          name="tax"
                          value={tax}
                          onChange={(e) => setTax(e.target.value)}
                          fullWidth
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <NumberField
                          label={tCommon('Additional Tax(%)')}
                          className={styles.numberInput}
                          name="additionalTax"
                          value={cess}
                          onChange={(e) => setCess(e.target.value)}
                          fullWidth
                        />
                      </Grid>
                    </>
                  )}

                  {ShopsHelper.hasPremiumAccess(shop) && (
                    <Grid item xs={12} sm={6}>
                      <TextField
                        label={tCommon('External Item ID')}
                        variant="outlined"
                        size="small"
                        type="text"
                        className={styles.numberInput}
                        name="ExternalItemId"
                        value={extenalId}
                        onChange={(e) => setExtenalId(e.target.value)}
                        fullWidth
                      />
                    </Grid>
                  )}
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label={tCommon('HSN')}
                      variant="outlined"
                      size="small"
                      type="text"
                      className={styles.numberInput}
                      name="hsnCode"
                      value={hsn}
                      onChange={(e) => setHsn(e.target.value)}
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <NumberField
                      label={tCommon('Display Order')}
                      className={styles.numberInput}
                      name="order"
                      value={order}
                      onChange={(e) => setOrder(e.target.value)}
                      fullWidth
                    />
                  </Grid>
                  {/* {ShopsHelper.hasPremiumAccess(shop) && ( */}
                  <Grid item xs={12} sm={12}>
                    <Autocomplete
                      openOnFocus
                      disablePortal
                      PopperProps={{ style: { zIndex: 14000 } }}
                      multiple
                      options={chargeGroups || []}
                      getOptionLabel={(option) => {
                        if (!option) return '';
                        return option.is_global ? `${option.name || ''} (${tCommon('default')})` : option.name || '';
                      }}
                      isOptionEqualToValue={(option, value) => String(option?.id) === String(value?.id)}
                      ListboxProps={{ style: { maxHeight: '300px', overflow: 'auto' } }}
                      value={(chargeGroups || []).filter((g) => (chargeGroup || []).map(String).includes(String(g.id)))}
                      onChange={(event, newValue) => {
                        const newSelection = newValue.map((v) => v.id);
                        setChargeGroup(newSelection);
                        if (newSelection.length > 0) {
                          setTax(0);
                          setCess(0);
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          label={tCommon('Charge / Discount Groups')}
                          placeholder={tCommon('Select Groups')}
                          size="small"
                        />
                      )}
                    />
                  </Grid>
                  {/* )} */}
                  <Grid item xs={12}>
                    <DescriptionField value={description} onChange={setDescription} />
                  </Grid>
                  <Grid container className={styles.inputRow} alignItems="center">
                    <Grid item xs={12} sm={4}>
                      <FormControlLabel
                        value="end"
                        control={
                          <Checkbox color="primary" checked={available} onChange={() => setAvailable(!available)} />
                        }
                        label={tCommon('Available for sale')}
                        labelPlacement="end"
                      />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <FormControlLabel
                        value="end"
                        control={
                          <Checkbox
                            color="primary"
                            checked={availableOnCart}
                            disabled={!ShopsHelper.hasPremiumAccess(shop)}
                            onChange={() => setAvailableOnCart(!availableOnCart)}
                          />
                        }
                        label={tCommon('Available On Cart')}
                        labelPlacement="end"
                      />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <FormControlLabel
                        value="end"
                        control={<Checkbox color="primary" checked={sync} onChange={() => setSync(!sync)} />}
                        label={tCommon('Export to Scale')}
                        labelPlacement="end"
                      />
                    </Grid>
                  </Grid>

                  {ShopsHelper.hasProAccess(shop) && (
                    <>
                      <Grid container m={1} className={styles.subContainer}>
                        <Grid>
                          <h3 className={styles.inputLabel}>{tCommon('Product schedule')}</h3>
                        </Grid>
                        <Grid container className={styles.inputRow} alignItems="center">
                          <Grid item xs={12} sm={2} className={styles.inputLabelContainer}>
                            <h3 className={styles.inputSubLabel}>{tCommon('Available Days')}</h3>
                          </Grid>
                          <Grid item xs={12} sm={10}>
                            <ToggleButtonGroup
                              value={selectedDays}
                              onChange={handleDayChange}
                              aria-label="days of the week"
                              size="small"
                              fullWidth
                            >
                              {Object.values(DAYS_OF_WEEK).map((day) => (
                                <ToggleButton
                                  key={day}
                                  value={day}
                                  aria-label={day}
                                  style={{
                                    padding: '6px',
                                    color: selectedDays.includes(day) ? '#fff' : '#333',
                                    backgroundColor: selectedDays.includes(day) ? '#0b8300a8' : '#ffffff00',
                                    border: '1px solid #ccc',
                                    borderRadius: 3,
                                    fontWeight: 500,
                                  }}
                                >
                                  {day}
                                </ToggleButton>
                              ))}
                            </ToggleButtonGroup>
                          </Grid>
                        </Grid>

                        {timeRanges.map((tr, idx) => (
                          <Grid container className={styles.inputRow} alignItems="center" key={idx}>
                            <Grid item xs={12} sm={2} display="flex" className={styles.inputLabelContainer}>
                              {idx === 0 ? (
                                <h3 className={styles.inputSubLabel}>{tCommon('Available Time')}</h3>
                              ) : (
                                <h3 className={styles.inputSubLabel} style={{ visibility: 'hidden' }}>
                                  {tCommon('Available Time')}
                                </h3>
                              )}
                            </Grid>

                            <Grid item xs={12} sm={10}>
                              <Grid container spacing={1} alignItems="center">
                                <Grid item xs={5}>
                                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <TimePicker
                                      label={tCommon('Start Time')}
                                      value={tr.from}
                                      onChange={(newVal) => handleTimeRangeChange(idx, 'from', newVal)}
                                      format="hh:mma"
                                      slotProps={{
                                        textField: {
                                          size: 'small',
                                          fullWidth: true,
                                          InputProps: {
                                            sx: {
                                              fontSize: '0.875rem',
                                              alignItems: 'center',
                                            },
                                          },
                                        },
                                      }}
                                    />
                                  </LocalizationProvider>
                                </Grid>

                                <Grid item xs={5} style={{ paddingLeft: 12 }}>
                                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <TimePicker
                                      label={tCommon('End Time')}
                                      value={tr.to}
                                      onChange={(newVal) => handleTimeRangeChange(idx, 'to', newVal)}
                                      format="hh:mma"
                                      slotProps={{
                                        textField: {
                                          size: 'small',
                                          fullWidth: true,
                                          InputProps: {
                                            sx: {
                                              fontSize: '0.875rem',
                                              alignItems: 'center',
                                            },
                                          },
                                        },
                                      }}
                                    />
                                  </LocalizationProvider>
                                </Grid>

                                <Grid item xs={2}>
                                  <IconButton
                                    size="small"
                                    onClick={() => removeRangeRow(idx)}
                                    disabled={timeRanges.length === 1}
                                  >
                                    <DeleteIcon />
                                  </IconButton>
                                </Grid>
                              </Grid>
                            </Grid>
                          </Grid>
                        ))}

                        <Grid container>
                          <Grid item xs={12} sm={12} p={1}>
                            <Button
                              size="small"
                              variant="outlined"
                              startIcon={<LibraryAddIcon />}
                              onClick={addRangeRow}
                            >
                              <span style={{ paddingTop: 5 }}>{tCommon('Add New Time Schedule')}</span>
                            </Button>
                          </Grid>
                        </Grid>
                      </Grid>

                      {/* Price Categories */}
                      <Grid container m={1} className={styles.subContainer}>
                        <Grid>
                          <h3 className={styles.inputLabel}>{tCommon('Price Categories')}</h3>
                        </Grid>
                        <Grid className={styles.inputRow} alignItems="center">
                          <TableContainer className={styles.tableContainer} component={Paper}>
                            <Table aria-label="customized table" sx={{ tableLayout: 'fixed', width: '100%' }}>
                              <TableHead>
                                <TableRow>
                                  <TableCell style={{ minWidth: '50px' }} className={styles.columnCell}>
                                    {tCommon('Category')}
                                  </TableCell>
                                  <TableCell style={{ minWidth: '150px' }} className={styles.nameColumn}>
                                    {tCommon('Min Qty')}
                                  </TableCell>
                                  <TableCell style={{ minWidth: '100px' }} className={styles.columnCell}>
                                    {tCommon('Price')}
                                  </TableCell>
                                  <TableCell className={styles.columnCell}>{tCommon('Actions')}</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {priceCategoryItems.length > 0 &&
                                  priceCategoryItems.map((categoryItem) => (
                                    <TableRow key={categoryItem.name}>
                                      <TableCell>{categoryItem.categoryName}</TableCell>
                                      <TableCell>{categoryItem.minimum_quantity}</TableCell>
                                      <TableCell>{categoryItem.price}</TableCell>
                                      <TableCell style={{ display: 'flex' }}>
                                        <IconButton onClick={() => handleDltCategoryItem(categoryItem)}>
                                          <DeleteIcon />
                                        </IconButton>
                                        <IconButton onClick={() => handleEditCategoryItem(categoryItem)}>
                                          <EditIcon />
                                        </IconButton>
                                      </TableCell>
                                    </TableRow>
                                  ))}
                                <TableRow key={selectedPriceCategoryItem?.category_id} ref={priceCategorySectionRef}>
                                  <TableCell>
                                    <TextField
                                      select
                                      fullWidth
                                      variant="outlined"
                                      size="small"
                                      label={tCommon('Search by category')}
                                      value={selectedPriceCategoryItem?.category_id || ''}
                                      onChange={(e) => {
                                        const catId = e.target.value;
                                        const catList = Array.isArray(priceCategories?.data)
                                          ? priceCategories.data
                                          : [];
                                        const selectedCat = catList.find((cat) => cat.id === catId);
                                        setSelectedPriceCategoryItem({
                                          category_id: catId || '',
                                          categoryName: selectedCat?.name || '',
                                        });
                                      }}
                                      SelectProps={{
                                        MenuProps: { style: { zIndex: 10001 } },
                                      }}
                                      style={{ minWidth: '240px' }}
                                    >
                                      <MenuItem value="">
                                        <em>None</em>
                                      </MenuItem>
                                      {(priceCategories || []).map((cat) => (
                                        <MenuItem key={cat.id} value={cat.id}>
                                          {cat.name}
                                        </MenuItem>
                                      ))}
                                    </TextField>
                                  </TableCell>
                                  <TableCell>
                                    <NumberField
                                      label={tCommon('Min Qty')}
                                      value={selectedPriceCategoryItem?.minimum_quantity || ''}
                                      onChange={(e) =>
                                        setSelectedPriceCategoryItem((prev) => ({
                                          ...prev,
                                          minimum_quantity: Number(e.target.value),
                                        }))
                                      }
                                      style={{ minWidth: '95px' }}
                                    />
                                  </TableCell>
                                  <TableCell>
                                    <NumberField
                                      label={tCommon('Price')}
                                      value={selectedPriceCategoryItem?.price || ''}
                                      onChange={(e) =>
                                        setSelectedPriceCategoryItem((prev) => ({
                                          ...prev,
                                          price: Number(e.target.value),
                                        }))
                                      }
                                      style={{ minWidth: '95px' }}
                                    />
                                  </TableCell>
                                  <TableCell style={{ display: 'flex' }}>
                                    <IconButton
                                      disabled={
                                        !selectedPriceCategoryItem?.category_id ||
                                        !selectedPriceCategoryItem?.minimum_quantity ||
                                        !selectedPriceCategoryItem?.price
                                      }
                                      onClick={() => handleAddCategoryItem(selectedPriceCategoryItem)}
                                    >
                                      <AddCircleIcon />
                                    </IconButton>
                                    <IconButton
                                      disabled={Object.keys(selectedPriceCategoryItem).length === 0}
                                      onClick={() => {
                                        setSelectedPriceCategoryItem({});
                                      }}
                                    >
                                      <DeleteIcon />
                                    </IconButton>
                                  </TableCell>
                                </TableRow>
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </Grid>
                      </Grid>

                      {/* Product Options */}
                      <Grid container m={1} className={styles.subContainer}>
                        <Grid item xs={12}>
                          <h3 className={styles.inputLabel}>{tCommon('Product options')}</h3>
                        </Grid>
                        <Grid container className={styles.inputRow} alignItems="center">
                          <TableContainer className={styles.addonTableContainer} component={Paper}>
                            <Table aria-label="customized table" sx={{ tableLayout: 'fixed', width: '100%' }}>
                              <TableHead>
                                <TableRow className={styles.addonTableHeader}>
                                  <TableCell className={styles.addonTableHeader} style={{ width: '30%' }}>
                                    {tCommon('Label')}
                                  </TableCell>
                                  <TableCell className={styles.addonTableHeader} style={{ width: '25%' }}>
                                    {tCommon('Quantity Ratio')}
                                  </TableCell>
                                  <TableCell className={styles.addonTableHeader} style={{ width: '25%' }}>
                                    {tCommon('Price')}
                                  </TableCell>
                                  <TableCell className={styles.addonTableHeader} align="right" style={{ width: '20%' }}>
                                    {tCommon('Actions')}
                                  </TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {productOptions.length > 0 &&
                                  productOptions.map((option) => (
                                    <TableRow key={option.label} className={styles.addonRow}>
                                      <TableCell>{option.label}</TableCell>
                                      <TableCell>{option.quantity_ratio}</TableCell>
                                      <TableCell>
                                        <span
                                          style={{
                                            padding: '4px 8px',
                                            borderRadius: '4px',
                                            backgroundColor: '#e8f0fe',
                                            color: '#1d57ac',
                                            fontWeight: 600,
                                            fontSize: '12px',
                                          }}
                                        >
                                          {option.price || 0}
                                        </span>
                                      </TableCell>
                                      <TableCell align="right">
                                        <IconButton
                                          onClick={() => handleEditProductOption(option)}
                                          size="small"
                                          style={{ color: '#1d57ac' }}
                                        >
                                          <EditIcon fontSize="small" />
                                        </IconButton>
                                        <IconButton
                                          onClick={() => handleDltCategoryItem(option)}
                                          size="small"
                                          style={{ color: '#d32f2f' }}
                                        >
                                          <DeleteIcon fontSize="small" />
                                        </IconButton>
                                      </TableCell>
                                    </TableRow>
                                  ))}
                                <TableRow>
                                  <TableCell>
                                    <TextField
                                      label={tCommon('Label')}
                                      variant="outlined"
                                      size="small"
                                      fullWidth
                                      type="text"
                                      value={selectedProductOption?.label || ''}
                                      onChange={(e) =>
                                        setSelectedProductOption((prev) => ({
                                          ...prev,
                                          label: e.target.value,
                                        }))
                                      }
                                    />
                                  </TableCell>
                                  <TableCell>
                                    <NumberField
                                      label={tCommon('Qty Ratio')}
                                      value={selectedProductOption?.quantity_ratio || ''}
                                      onChange={(e) => {
                                        const txt = e.target.value;
                                        if (txt === '') {
                                          setSelectedProductOption((prev) => ({
                                            ...prev,
                                            quantity_ratio: '',
                                          }));
                                        } else {
                                          const quantity_ratio = parseFloat(txt);
                                          setSelectedProductOption((prev) => ({
                                            ...prev,
                                            quantity_ratio: isNaN(quantity_ratio) ? '' : quantity_ratio,
                                          }));
                                        }
                                      }}
                                    />
                                  </TableCell>
                                  <TableCell>
                                    <NumberField
                                      label={tCommon('Price')}
                                      value={selectedProductOption?.price || ''}
                                      onChange={(e) => {
                                        const txt = e.target.value;
                                        if (txt === '') {
                                          setSelectedProductOption((prev) => ({
                                            ...prev,
                                            price: '',
                                          }));
                                        } else {
                                          const price = parseFloat(txt) || 0;
                                          setSelectedProductOption((prev) => ({
                                            ...prev,
                                            price,
                                          }));
                                        }
                                      }}
                                    />
                                  </TableCell>
                                  <TableCell align="right">
                                    <IconButton
                                      disabled={!selectedProductOption?.label}
                                      onClick={() => handleAddProductOption(selectedProductOption)}
                                      style={{ color: '#00a65a' }}
                                    >
                                      <AddCircleIcon />
                                    </IconButton>
                                    <IconButton
                                      disabled={
                                        Object.keys(selectedProductOption).length === 0 ||
                                        (selectedProductOption?.label === undefined &&
                                          selectedProductOption?.price === undefined &&
                                          selectedProductOption?.quantity_ratio === 1)
                                      }
                                      onClick={() => {
                                        setSelectedProductOption({ quantity_ratio: 1 });
                                      }}
                                      style={{ color: '#5f6368' }}
                                    >
                                      <DeleteIcon />
                                    </IconButton>
                                  </TableCell>
                                </TableRow>
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </Grid>
                      </Grid>

                      {/* Addon Items Section */}
                      <Grid container m={1} className={styles.subContainer}>
                        <Grid item xs={12}>
                          <h3 className={styles.inputLabel}>{tCommon('Addon Items')}</h3>
                        </Grid>
                        <Grid container className={styles.inputRow} alignItems="center">
                          <TableContainer className={styles.addonTableContainer} component={Paper}>
                            <Table aria-label="customized table" sx={{ tableLayout: 'fixed', width: '100%' }}>
                              <TableHead>
                                <TableRow className={styles.addonTableHeader}>
                                  <TableCell className={styles.addonTableHeader} style={{ width: '28%' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                      <LibraryAddIcon style={{ fontSize: '14px', color: '#1d57ac' }} />
                                      {tCommon('Item')}
                                    </div>
                                  </TableCell>
                                  <TableCell className={styles.addonTableHeader} style={{ width: '32%' }} align="left">
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                      <AddCircleIcon style={{ fontSize: '14px', color: '#1d57ac' }} />
                                      {tCommon('Price Delta')}
                                    </div>
                                  </TableCell>
                                  <TableCell className={styles.addonTableHeader} style={{ width: '22%' }} align="left">
                                    {tCommon('Maximum Quantity')}
                                  </TableCell>
                                  <TableCell className={styles.addonTableHeader} style={{ width: '9%' }} align="center">
                                    {tCommon('Active')}
                                  </TableCell>
                                  <TableCell className={styles.addonTableHeader} align="right" style={{ width: '9%' }}>
                                    <div
                                      style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'flex-end',
                                        gap: '8px',
                                      }}
                                    >
                                      <EditIcon style={{ fontSize: '14px', color: '#1d57ac' }} />
                                      {tCommon('Actions')}
                                    </div>
                                  </TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {itemAddons.length > 0 &&
                                  itemAddons.map((itemAddon) => (
                                    <TableRow key={itemAddon.addon_item_id} className={styles.addonRow}>
                                      <TableCell>
                                        {itemAddon.itemName ||
                                          (items || []).find((itm) => itm.id === itemAddon.addon_item_id)?.name}
                                      </TableCell>
                                      <TableCell>
                                        <span
                                          style={{
                                            padding: '4px 8px',
                                            borderRadius: '4px',
                                            backgroundColor: itemAddon.price_delta >= 0 ? '#e6f4ea' : '#fce8e6',
                                            color: itemAddon.price_delta >= 0 ? '#137333' : '#c5221f',
                                            fontWeight: 600,
                                            fontSize: '12px',
                                          }}
                                        >
                                          {itemAddon.price_delta > 0
                                            ? `+${itemAddon.price_delta}`
                                            : itemAddon.price_delta < 0
                                            ? `${itemAddon.price_delta}`
                                            : 0}
                                        </span>
                                      </TableCell>
                                      <TableCell>{itemAddon.max_quantity}</TableCell>
                                      <TableCell align="center">
                                        <span style={{ color: itemAddon.is_available ? '#00a65a' : '#d93025' }}>
                                          {itemAddon.is_available ? tCommon('Yes') : tCommon('No')}
                                        </span>
                                      </TableCell>
                                      <TableCell align="right">
                                        <IconButton
                                          onClick={() => handleEditAddon(itemAddon)}
                                          size="small"
                                          style={{ color: '#1d57ac' }}
                                        >
                                          <EditIcon fontSize="small" />
                                        </IconButton>
                                        <IconButton
                                          onClick={() => handleDltAddon(itemAddon)}
                                          size="small"
                                          style={{ color: '#d32f2f' }}
                                        >
                                          <DeleteIcon fontSize="small" />
                                        </IconButton>
                                      </TableCell>
                                    </TableRow>
                                  ))}
                                <TableRow key={selectedAddon?.addon_item_id} ref={addonSectionRef}>
                                  <TableCell>
                                    <Autocomplete
                                      fullWidth
                                      size="small"
                                      openOnFocus
                                      disablePortal
                                      value={
                                        (items || []).find((item) => item.id === selectedAddon?.addon_item_id) || null
                                      }
                                      onChange={(event, newValue) => {
                                        if (newValue) {
                                          setSelectedAddon({
                                            ...selectedAddon,
                                            addon_item_id: newValue.id,
                                            name: newValue.name,
                                          });
                                        } else {
                                          setSelectedAddon({
                                            ...selectedAddon,
                                            addon_item_id: null,
                                            name: '',
                                          });
                                        }
                                      }}
                                      options={Array.isArray(items) ? items : items?.data || []}
                                      getOptionLabel={(option) => {
                                        if (typeof option === 'string') return option;
                                        if (!option) return '';
                                        return option.plu ? `${option.plu} - ${option.name || ''}` : option.name || '';
                                      }}
                                      getOptionSelected={(option, value) => option.id === value?.id}
                                      filterOptions={(options, { inputValue }) => {
                                        const search = (inputValue || '').toLowerCase();
                                        return options.filter((option) => {
                                          const name = (option?.name || '').toLowerCase();
                                          const plu = (option?.plu || '').toString().toLowerCase();
                                          return name.includes(search) || plu.includes(search);
                                        });
                                      }}
                                      PopperProps={{ style: { zIndex: 10001 } }}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          label={tCommon('Search by items')}
                                          variant="outlined"
                                          size="small"
                                          fullWidth
                                        />
                                      )}
                                    />
                                  </TableCell>
                                  <TableCell>
                                    <div className={styles.priceDeltaGrid}>
                                      <NumberField
                                        label={tCommon('Price Delta')}
                                        value={selectedAddon?.price_delta || ''}
                                        onChange={(e) =>
                                          setSelectedAddon((prev) => ({
                                            ...prev,
                                            price_delta: Number(e.target.value),
                                          }))
                                        }
                                        fullWidth
                                      />
                                      <ToggleButtonGroup
                                        value={addonDeltaType}
                                        exclusive
                                        onChange={(e, val) => {
                                          if (val !== null) setAddonDeltaType(val);
                                        }}
                                        className={styles.typeToggleGroup}
                                        size="small"
                                      >
                                        <ToggleButton value={DELTA_TYPE.LESS} className={styles.typeToggleButton}>
                                          {tCommon('Less')}
                                        </ToggleButton>
                                        <ToggleButton value={DELTA_TYPE.MORE} className={styles.typeToggleButton}>
                                          {tCommon('More')}
                                        </ToggleButton>
                                      </ToggleButtonGroup>
                                    </div>
                                  </TableCell>
                                  <TableCell>
                                    <NumberField
                                      label={tCommon('Max Qty')}
                                      value={selectedAddon?.max_quantity || ''}
                                      onChange={(e) =>
                                        setSelectedAddon((prev) => ({
                                          ...prev,
                                          max_quantity: Number(e.target.value),
                                        }))
                                      }
                                    />
                                  </TableCell>
                                  <TableCell align="center">
                                    <Checkbox
                                      color="primary"
                                      checked={selectedAddon?.is_available}
                                      onChange={() =>
                                        setSelectedAddon((prev) => ({
                                          ...prev,
                                          is_available: !prev.is_available,
                                        }))
                                      }
                                      size="small"
                                    />
                                  </TableCell>
                                  <TableCell align="right">
                                    <IconButton
                                      disabled={!selectedAddon?.addon_item_id || !selectedAddon?.price_delta}
                                      onClick={() => handleAddAddon(selectedAddon)}
                                      style={{ color: '#00a65a' }}
                                    >
                                      <AddCircleIcon />
                                    </IconButton>
                                    <IconButton
                                      onClick={() => setSelectedAddon({})}
                                      disabled={Object.keys(selectedAddon).length === 0}
                                      style={{ color: '#5f6368' }}
                                    >
                                      <DeleteIcon />
                                    </IconButton>
                                  </TableCell>
                                </TableRow>
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </Grid>
                      </Grid>

                      {/* Product Tags Section */}
                      <Grid container m={1} className={styles.subContainer}>
                        <Grid>
                          <h3 className={styles.inputLabel}>{tCommon('Product Tags')}</h3>
                        </Grid>
                        <Grid container className={styles.inputRow} alignItems="center">
                          <TableContainer className={styles.tableContainer} component={Paper}>
                            <Table aria-label="customized table" sx={{ tableLayout: 'fixed', width: '100%' }}>
                              <TableHead>
                                <TableRow>
                                  <TableCell>
                                    <strong>{tCommon('Key')}</strong>
                                  </TableCell>
                                  <TableCell>
                                    <strong>{tCommon('Value')}</strong>
                                  </TableCell>
                                  <TableCell></TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {tags.map((row, index) => (
                                  <TableRow key={index}>
                                    <TableCell>
                                      <Autocomplete
                                        freeSolo
                                        size="small"
                                        options={getKeySuggestions(row.key)}
                                        value={row.key}
                                        onChange={(e, newValue) => handleChange(index, 'key', newValue || '')}
                                        onInputChange={(e, newValue) => handleChange(index, 'key', newValue)}
                                        PopperProps={{ style: { zIndex: 10001 } }}
                                        renderInput={(params) => (
                                          <TextField {...params} placeholder={tCommon('Key')} variant="outlined" />
                                        )}
                                      />
                                    </TableCell>

                                    <TableCell>
                                      <Autocomplete
                                        freeSolo
                                        size="small"
                                        options={getValueSuggestions(row.key)}
                                        value={row.value}
                                        onChange={(e, newValue) => handleChange(index, 'value', newValue || '')}
                                        onInputChange={(e, newValue) => handleChange(index, 'value', newValue)}
                                        PopperProps={{ style: { zIndex: 10001 } }}
                                        renderInput={(params) => (
                                          <TextField {...params} placeholder={tCommon('Value')} variant="outlined" />
                                        )}
                                      />
                                    </TableCell>

                                    <TableCell align="right">
                                      <IconButton
                                        color="error"
                                        size="small"
                                        onClick={() => handleDeleteRow(index)}
                                        disabled={tags.length === 1}
                                      >
                                        <DeleteIcon />
                                      </IconButton>
                                    </TableCell>
                                  </TableRow>
                                ))}

                                <Grid container>
                                  <Grid item xs={12} sm={12} p={1}>
                                    <Button
                                      startIcon={<LibraryAddIcon />}
                                      onClick={handleAddRow}
                                      size="small"
                                      variant="outlined"
                                    >
                                      {tCommon('Add New Tag')}
                                    </Button>
                                  </Grid>
                                </Grid>
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </Grid>
                      </Grid>
                    </>
                  )}
                </>
              )}
            </Grid>
          </div>
          <div className={styles.footSec}>
            <DialogActions style={{ gap: '12px', padding: '0 25px' }}>
              <Button
                variant="outlined"
                color="secondary"
                size="medium"
                onClick={handleClose}
                disabled={isLoading}
                style={{ borderRadius: '10px', textTransform: 'none', fontWeight: 600, minWidth: '100px' }}
              >
                {tCommon('Close')}
              </Button>
              <Button
                variant="contained"
                size="medium"
                color="primary"
                style={{
                  backgroundColor: '#00a65a',
                  borderRadius: '10px',
                  textTransform: 'none',
                  fontWeight: 600,
                  minWidth: '140px',
                  boxShadow: '0 4px 14px 0 rgba(0,166,90,0.39)',
                }}
                disabled={name === '' || price === '' || unit === '' || category === '' || isLoading}
                onClick={onAddItemButtonClicked}
              >
                {isLoading ? (
                  <>
                    <CircularProgress size={20} color="inherit" style={{ marginRight: '10px' }} />
                    {tCommon('Creating...')}
                  </>
                ) : (
                  tCommon('Create Item')
                )}
              </Button>
            </DialogActions>
          </div>
        </div>
      </div>
      {isShowSelectShopsDialog && (
        <SelectShopsDialog
          onClose={closeOtherShopsSelectionDialog}
          onShopsSelected={onOtherShopsSelected}
          message={tPopup('Do you want to update item with PLU in all shops?')}
        />
      )}

      {isShowAddCategoryDialog && (
        <AddCategoryDialog handleClose={closeCreateCategoryDialog} onSuccess={onCreateCategory} />
      )}
    </>
  );
}
